<template>
  <div>   
    <v-alert 
      v-if="familiasResetadasParaReanalise && $verificaPerfilHabilitador()"
      type="warning"
      outlined
      prominent
      class="ma-4 mb-6"
      border="left"
      dismissible
      @input="familiasResetadasParaReanalise = false"
    >
      <v-row align="center">
        <v-col class="grow">
          <div class="font-weight-black text-h6">
            <v-icon color="warning" class="mr-2">warning</v-icon>
            REANÁLISE DE FAMÍLIAS NECESSÁRIA
          </div>
          <div class="mt-2">
            <strong>{{ motivoReanalise }}</strong>
          </div>
          <div class="mt-2">
            <strong>{{ totalFamiliasResetadas }} família(s)</strong> que estavam 
            <span class="green--text">aprovadas</span> foram <strong>resetadas</strong> 
            e precisam ser <strong>reavaliadas</strong>:
          </div>
          <div class="mt-2" v-if="familiasAfetadas.length > 0">
            <v-chip 
              v-for="familia in familiasAfetadas" 
              :key="familia.codFamilia"
              color="orange"
              text-color="white"
              small
              class="ma-1"
            >
              {{ familia.codFamilia }}
            </v-chip>
          </div>
        </v-col>
        <v-col class="shrink">
          <v-btn
            color="orange"
            @click="familiasResetadasParaReanalise = false"
            small
          >
            <v-icon left>check</v-icon>
            Entendido
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-form v-model="validFormAdicionar" ref="familiaForm">
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <h1 class="text-info font-size-18">
            Cadastrar
            <strong>Família </strong>
          </h1>
        </div>
      </v-flex>
      <v-flex>
        <v-card class="boxInfoDoc" v-show="model.isEmpresaPublica || model.isFuncionarioPublico">
  <v-layout row wrap p-b-10>
    <v-flex>
      <fieldset>
        <legend>
          <strong class="text-primary">
            Por ser Socio servidor você só está apto para as seguintes famílias:
          </strong>
        </legend>
        <v-layout row wrap>
          <!-- Loop para exibir a lista de famílias -->
          <v-list-tile-content
            v-for="e in listaFamiliaSocios"
            :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ e.codGrupo+'.'+e.numFamilia + ' | ' }}
                </span>
              </template>
              {{ e.descFamilia }}
            </v-tooltip>
          </v-list-tile-content>

          <!-- Exceção para exibir Familia 01.46 mesmo que não esteja na lista -->
          <v-list-tile-content v-if="model.numCgcFornecedor === '020.333.605-47'" :key="'fe_01.46'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  01.46 |
                </span>
              </template>
              Familia 01.46 LOCACAO DE IMOVEIS
            </v-tooltip>
          </v-list-tile-content>

        </v-layout>
      </fieldset>
    </v-flex>
  </v-layout>
</v-card>



      </v-flex>
      <v-flex>
        


        <v-card>
          <v-layout row wrap class="p-t-5 p-b-5">
            <v-flex>
            <v-radio-group
              v-model="tipoFamilia"
             
              class="mb-0 mt-1"
              row
              persistent-hint
            >
              <v-radio  label="Material" value="Material"></v-radio>
              <v-radio label="Serviço" value="Serviço"></v-radio>
              <v-radio label="Ambos" value="Todos"></v-radio>
            </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="p-b-2">
            <v-flex xs12 v-bind:class="{sm9:!modelFamilia.familia,md10:!modelFamilia.familia}">
              <v-autocomplete
                :disabled="isLoadCombo"
                :loading="isLoadCombo"
                hint="Digite pelo menos 3 caracteres para pesquisar."
                :hide-no-data="hideNoData"
                persistent-hint
                validate-on-blur
                clearable               
                @click:clear="listaFamilia=[], hideNoData=true"
                v-model="modelFamilia.familia"
                :items="listaFamilia"
                color="blue-grey lighten-2"
                :label="$t('label.familia')+' *'"
                item-text="descFamilia"
                :return-object="true"
                :search-input.sync="pesquisaFamilia"
                :rules="validacao.campoObrigatorio.concat(validaFamilia)"
                @input="mergeAnexoFamilia() "
                required
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.descFamilia "></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.descGrupo" ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12
              v-bind:class="{'md7':Number(modelFamilia.familia.codGrupo)<10}"
              v-if="modelFamilia.familia"
            >
              <v-text-field
                v-model="modelFamilia.familia.descGrupo"
                :label="$t('label.ramoAtividade')"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md3
              v-bind:class="{'sm9':Number(modelFamilia.familia.codGrupo)<10,'sm12':Number(modelFamilia.familia.codGrupo)>9}"
              v-if="modelFamilia.familia"
            >
              <v-text-field
                v-model="modelFamilia.familia.tipoItem"
                :label="$t('label.tipoDoItem')"
                disabled
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm9 md9
              v-if="modelFamilia.familia "
            >
              <fieldset>
                <legend>{{$t('label.tipoDeQualificacao')}}</legend>
                <v-layout row wrap>
                  <v-flex>
                    <v-radio-group row
                      v-model="modelFamilia.familia.tipoQualificacao"
                      :rules="validacao.campoObrigatorio"
                      required
                    >
                      <v-radio :key="1" label="Fabricante" :value="1"></v-radio>
                      <v-radio :key="2" label="Revendedor" :value="2"></v-radio>
                      <v-radio :key="3" label="Distribuidor" :value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </fieldset>
            </v-flex>
              <v-layout wrap v-if="modelFamilia.familia && exibeCampoAtestado() && Number(modelFamilia.familia.codGrupo)<10">
                <v-flex xs12 sm9 md10 pt-2> <!--FlagEstrangeiro é para saber (0) Brasileiro / (1) Estrangeiro-->
                  <strong class="text-primary" v-if="model.flagEstrangeiro != 1">

                    <strong class="text-primary" v-if="exibirMsnCreaEmAnexarDocumento">
                  CERTIDÃO DE ACERVO TÉCNICO COM ATESTADO
                  </strong>
                 
                  <strong v-else class="text-primary">
                  ATESTADO DE CAPACIDADE TECNICA
                  </strong>                 
               
                </strong>
                  <strong v-else>
                    <strong  class="text-primary">
                        ATESTADO DE CAPACIDADE TÉCNICA COM TRADUÇÃO JURAMENTADA
                    </strong>
                    <span class="text-primary">
                      (OU DOCUMENTO EQUIVALENTE*)
                    </span>
                  </strong>
                </v-flex>

              <v-flex inputIcon v-show="!modelFamilia.anexoFamiliaVm.file.novoUpload">
                <v-text-field
                  :value="subStrUpload(modelFamilia.anexoFamiliaVm.arquivoUpload)"
                  :label="$t('label.anexaDocumento')+ ' *'"
                  append-icon="get_app"
                  clearable
                  @click:clear="modelFamilia.anexoFamiliaVm.file.novoUpload = true;modelFamilia.anexoFamiliaVm.file.arquivoUpload = null;"
                  @click:append="baixarArquivo(modelFamilia.anexoFamiliaVm.file.arquivoUpload)"
                ></v-text-field>
              </v-flex>

              <v-flex v-if="modelFamilia.anexoFamiliaVm.file.novoUpload">
                <uploadFile
                  tamanhoMaximo="20MB"
                  :required="this.model.tipoCertificado !== 3"
                  :label="$t('label.anexaDocumento')+ ' *'"
                  v-model="modelFamilia.anexoFamiliaVm.file.arquivoUpload"
                  accept=".pdf, .PDF"
                />
              </v-flex>
              <v-flex xs12 class="text-primary" v-if="model.flagEstrangeiro == 1 && modelFamilia.familia">
                *<sub>Conforme Lei nº 9.433/2005.</sub>
              </v-flex>
            </v-layout>
            <v-flex xs12 sm3 md2 my-auto>
              <v-btn @click="salvar()" large color="primary" dark class="mb-2">Adicionar</v-btn>
            </v-flex>

          </v-layout>
        </v-card>
      </v-flex>
      </v-form>
      <v-form v-model="validFormFamilias" ref="boxFamilias">
      <div class="p-t-30 boxFamilias">
        <v-layout
          row
          wrap
          class="p-t-10 p-b-20"
          v-for="item in familiaSolicitacao"
          :key="item.codGrupo+''+item.familiaAssociada.codFamilia + '_' + item.familiaFornecSituacao"
        >
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="50px"
                :class="{
                  'item-aprovado': (item.familiaFornecSituacao==2 && (model.tipoCertificado === 3 || !!item.anexoFamilia.arquivoUpload || Number(item.codGrupo) > 9)),
                  'item-reprovado': (item.familiaFornecSituacao==1 && (model.tipoCertificado === 3 || !!item.anexoFamilia.arquivoUpload || Number(item.codGrupo) > 9) || (model.tipoCertificado !== 3 && item.anexoFamilia.arquivoUpload === 'Não Encontrado')),
                  'familia-resetada-reanalise': familiaFoiResetada(item)
                }"
              >
                <v-toolbar-title>
                  <strong>{{item.familiaAssociada.codFamilia}}</strong>
                    -
                    {{item.familiaAssociada.descFamilia}}

                  <v-chip
                    v-if="familiaFoiResetada(item)"
                    color="orange"
                    text-color="white"
                    small
                    class="ml-2"
                  >
                  </v-chip>
                  <span v-html="ifNovafamilia(item.codGrupo,item.numFamilia)"></span>
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-tooltip top v-if="model.tipoCertificado === 3 || item.anexoFamilia.arquivoUpload != null || Number(item.codGrupo) > 9">
                  <v-icon
                    @click="aprovar(item,2)"
                    class="mx-1"
                    slot="activator"
                    color="green"
                  >spellcheck</v-icon>
                  <span>Aprovar</span>
                </v-tooltip>

                <v-tooltip top v-if="model.tipoCertificado === 3 || item.anexoFamilia.arquivoUpload != null || Number(item.codGrupo) > 9">
                  <v-icon
                    @click="openModalRejeitar(item, 1) "
                    class="mx-1"
                    slot="activator"
                    color="red accent-4"
                  >highlight_off</v-icon>
                  <span>Rejeitar</span>
                </v-tooltip>

                <v-btn icon @click="openBox(item)">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>

              <v-layout
                row
                wrap
                class="p-t-10 p-b-20"
                v-if="isShow[item.$id+'_'+item.codGrupo+'_'+item.familiaAssociada.codFamilia]"
              >
                <v-flex>
                  <v-card>
                    <v-layout row wrap class="p-t-10 p-b-20">
                      <v-flex xs12 v-bind:class="{'md9':Number(item.codGrupo)<10}">
                        <v-text-field
                          v-model="item.familiaAssociada.descGrupo"
                          :label="$t('label.ramoAtividade')"
                          disabled
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        xs12
                        md3
                        v-bind:class="{'sm12':Number(item.codGrupo)<10,'sm12':Number(item.codGrupo)>9}"
                      >
                        <v-text-field
                          v-model="item.familiaAssociada.tipoItem"
                          :label="$t('label.tipoDoItem')"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md9 v-if="Number(item.codGrupo)>9">
                        <fieldset>
                          <legend>{{$t('label.tipoDeQualificacao')}}</legend>
                          <v-layout row wrap>
                            <v-flex>
                              <v-radio-group row v-model="item.tipoQualificacao">
                                <v-radio :key="1" label="Fabricante" :value="1" @change="updateItem(item)"></v-radio>
                                <v-radio :key="2" label="Distribuidor" :value="2" @change="updateItem(item)"></v-radio>
                                <v-radio :key="3" label="Revendedor" :value="3" @change="updateItem(item)"></v-radio>
                              </v-radio-group>
                            </v-flex>
                          </v-layout>
                        </fieldset>
                      </v-flex>
                      <v-layout wrap v-if="exibeCampoAtestado() && Number(item.codGrupo)<10">
                        <v-flex xs12  v-if="model.tipoCertificado != 3">
                            <strong class="text-primary" v-if="model.flagEstrangeiro != 1">
                              <strong class="text-primary" v-if="comparacaoCodModeloFamilia.includes(item.familiaAssociada.codFamilia)">
                              CERTIDÃO DE ACERVO TÉCNICO COM ATESTADO
                                </strong>
                              
                                <strong v-else class="text-primary">
                                ATESTADO DE CAPACIDADE TECNICA
                                </strong>    
                                </strong>  
                            <div v-else>
                              <strong class="text-primary">
                                 ATESTADO DE CAPACIDADE TÉCNICA COM TRADUÇÃO JURAMENTADA
                              </strong>
                              <span class="text-primary">
                                (OU DOCUMENTO EQUIVALENTE )
                              </span>
                            </div>
                        </v-flex>
                          <v-flex xs12 inputIcon v-show="!item.anexoFamilia.file.novoUpload">
                            <v-text-field
                              :value="subStrUpload(arquivoAnexoFamilia(item.anexoFamilia))"
                              :label="$t('label.anexaDocumento')+ (verificaObrigatorio() ? ' *' : '')"
                              append-icon="get_app"
                              @click:append="baixarArquivo(arquivoAnexoFamilia(item.anexoFamilia))"
                              :hint="ifAnexoFamiliaAlterado(item.codGrupo,item.numFamilia,item.anexoFamilia)"
                              persistent-hint
                            >
                              <template slot="append-outer">
                                <v-icon @click="iconDelete(item)">clear</v-icon>
                              </template>
                            </v-text-field>
                          </v-flex>

                          <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
                            <v-card>
                              <v-card-title class="headline">Atenção!</v-card-title>
                              <v-form>
                                <v-layout row wrap>
                                  <v-flex xs12><br />
                                    Deseja excluir o documento?
                                  </v-flex>
                                </v-layout><br /><br />
                                <v-layout wrap p-b-10>
                                  <v-flex xs12 sm6>
                                    <v-btn @click="cancelarDialog()">Não</v-btn>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-btn color="info" @click="limparArquivoTemp()" :loading="isLoading">Sim</v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-form>
                            </v-card>
                          </v-dialog>

                          <v-flex xs12 v-if="item.anexoFamilia.file.novoUpload && ((model.tipoCertificado != 3 || $verificaPerfilHabilitador()) &&  Number(item.codGrupo)<10 )">
                            <uploadFile
                              tamanhoMaximo="20MB"
                              :required="verificaObrigatorio()"
                              :label="$t('label.anexaDocumento')+ (verificaObrigatorio() ? ' *' : '') "
                              v-model="item.anexoFamilia.file.arquivoUpload"
                              accept=".pdf, .PDF"
                            />
                          </v-flex>
                          <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                            *
                            <sub>
                              Conforme Lei nº 9.433/2005.
                            </sub>
                          </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

  <v-dialog v-model="dialogoVisivel" max-width="400"> <!-- Defina a largura máxima do dialog -->
    <v-card>
      <v-card-title>Lei nº 9.433 de 01 de Março de 2005</v-card-title>
      <v-card-text>
        <div>
          <p>Art. 125 - É vedado ao agente político e ao servidor público de qualquer categoria, natureza ou condição, celebrar contratos com a Administração direta ou indireta, por si ou como representante de terceiro, sob pena de nulidade, ressalvadas as exceções legais.</p>
          <p>Parágrafo único - Não se inclui na vedação deste artigo a prestação de serviços em caráter eventual, de consultoria técnica, treinamento e aperfeiçoamento, bem como a participação em comissões examinadoras de concursos, no âmbito da Administração Pública.</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" dark class="mb-2" @click="fecharDialogo">OK</v-btn> <!-- Defina o tamanho pequeno do botão -->
      </v-card-actions>
    </v-card>
  </v-dialog>


    </v-form>
    <dialogMotivoIndeferimento
      :config="modelDialogRejeitar"
      v-on:observacaoOk="rejeitar()"
      v-on:observacaoCancel="fnAcaoModalCancelar()"
    />
  </div>
</template>

<script>
import familiaService from "../../../services/familiaService";
import fornecedorService from "../../../services/fornecedorService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import analiseCampoAlterado from "./components/analiseCampoAlterado";
export default {
  name: "familia",
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    erroFamilia: Object,
    listaDocsQualificacaoTecnica: Object,
    getListaDocsQualificacaoTecnica: Function,
    OldModel: Object
  },
  mixins: [util,analiseCampoAlterado],

  watch: { //Propriedades assistidas
    pesquisaFamilia(newValor, oldValor) {
      this.pesquisaCombo(
        newValor,
        oldValor,
        "listaFamilia",
        eval("this.listaFamilia"),
        "model.familia",
        this.getFamilia,
        2
      );
    }
  },
  computed:{
    familiaSolicitacao(){
      return this.model.familiaSolicitacao;
    }
  },
  data() {
    return {
      dialog: false,
      valorRef: '',
      comparacaoCodModeloFamilia: null,
      exibirMsnCreaEmAnexarDocumento: null,// valor booleano
      exibirMsnCAOEmAnexarDocumento: null,
      comparacaoCodModeloFamiliaCAO_: [],
      tipoFamilia: "Todos",
      validFormAdicionar:true,
      validFormFamilias:true,
      dialogoVisivel: false,
      isShow: {},
      pesquisaFamilia: null,
      cadastrouSocioServidor: false,
      modelFamilia: {},
      tipoDocumento: {},
      isLoadCombo: false,
      listaFamiliaSocios: [],
      listaFamilia: [],
      listaFamiliaNova: [],
      validaFamilia: [
        v =>
          (v && this.validaFamiliaDuplicidade(v)) ||
          this.$t("messages.validacao.familiaJaAssociada")
      ],
      modelDialogRejeitar: {
        open: false,
        obs: null,
        titulo: "Motivo",
        codDocumento:null,
        codGrupo:0,
        numFamilia:0,
        motivoSelecionado:0
      },
      itemRejeitado: {},
      //listaDocsFamilia: [],
      arrayFamiliasDocumento: [],
      contratoSocialFoiAlterado: false, // NOVA FLAG
      familiasResetadasParaReanalise: false, // NOVA FLAG
      motivoReanalise: '', // NOVA FLAG
      familiasAfetadas: [], // NOVA FLAG - Lista das famílias resetadas
      totalFamiliasResetadas: 0, // NOVA FLAG
    };
  },
  created(){
    familiaService.getFamiliaCAO().then(response => {
      const originalData = response.data;
      this.comparacaoCodModeloFamiliaCAO_ = originalData.map(item => `${item.codGrupo}.${item.numFamilia}`);
    });

    this.$store.commit("setAba", {abaAtiva: "tab-familia"});
    
    familiaService.getListaFamiliaCatalagoMat(" ").then(response => {
      response.data.filter(item => {
        this.listaFamiliaSocios.push(item);         
      });
    });
    
    // === NOVOS LISTENERS (APENAS PARA VALIDADORES) ===
    if (this.$verificaPerfilHabilitador()) {
      // LIMPAR LISTENERS EXISTENTES
      this.$root.$off('contratoSocialAlterado');
      this.$root.$off('familiasResetadasParaReanalise');
      
      // Event listeners com arrow functions ✅
      this.$root.$on('contratoSocialAlterado', (data) => {
        if (data.alterado && data.exigeReanaliseFamily) {
       
          this.contratoSocialFoiAlterado = true;
          this.motivoReanalise = 'Alteração no Contrato Social detectada';
        }
      });
      
      this.$root.$on('familiasResetadasParaReanalise', (data) => {
        if (data.resetadas) {
      
          
          if (this.familiasResetadasParaReanalise) {
         
            return;
          }
          
          this.familiasResetadasParaReanalise = true;
          this.motivoReanalise = data.motivoReanalise;
          this.familiasAfetadas = data.familiasAfetadas || [];
          this.totalFamiliasResetadas = data.totalResetadas || 0;
          
          if (this.$toasted) {
            this.$toasted.info(
              `${data.totalResetadas} família(s) foram resetadas para reanálise devido à alteração do Contrato Social`,
              {
                duration: 8000,
                position: 'top-center'
              }
            );
          }
        }
      });
    }
  },
  
  mounted() {
    this.listaComparacaoCodModeloFamilia();  


  },
  methods: {
    getSocio(){

        this.model.fornecedoresHabilitacaoJuridica.filter(item => {    
        
        if(item.isFuncionarioPublico) {
          this.cadastrouSocioServidor = true;
        }
              
        });
        },
    exibirDialogo() {
      this.dialogoVisivel = true;
    },
    fecharDialogo() {
      this.dialogoVisivel = false;
      this.modelFamilia.familia = null;
    },
    iconDelete(item) {
      this.dialog = true;
      this.valorRef = item;
    },
    cancelarDialog() {
      this.dialog = false;
    },
    limparArquivoTemp() {
      var aa = this.valorRef;
      aa.anexoFamilia.file.novoUpload = true;
      aa.anexoFamilia.file.arquivoUpload = null;
      this.dialog = false;
    },
    exibeCampoAtestado() {
      //No ticket 157260 pediu para que os estrangeiros registrassem o Atestado de capacidade técnica
     
      return (this.model.tipoCertificado !== 3 || this.model.flagEstrangeiro == 1) ; 
    
    },
     listaComparacaoCodModeloFamilia(item){
      //Listas com os  codigos das Familias para comparação, e ver se tem ou não Crea.
      //Essa lista aqui são familas que são Exigidos: "Crea-cons regional de eng e agronomia e Certidão de acervo técnico com atestado"

       const listaCodFamiliaComCrea=[
        //Codigo das Familias familias estão em modelFamilia.familia.codFamilia, lista para comparação:
        '02.04','02.11','02.14','02.27','02.39','02.48','03.01','03.04','03.19','03.20','03.21','03.31','03.34','04.02','04.04',
        '04.07','04.08','04.09','04.11','04.12','04.13','04.14','04.16','04.17','04.18','04.19','04.20','04.21','04.22','04.23',
        '04.26','04.27','04.28','04.30','04.32','04.35','04.37','04.38','04.39','04.40','04.41','04.42','04.43','04.49','04.51',
        '04.52','04.56','04.68','06.01','06.02','06.03','06.04','06.05','06.06','06.09','06.10','06.11','06.12','06.13','06.14',
        '06.15','06.16','06.17','06.18','06.19','06.20','06.21','06.22','06.23','06.24','06.25','06.26','06.27','06.28','06.29',
        '06.30','06.31','06.32','06.33','06.34','06.35','06.36','06.38','06.39','06.40','06.41','06.42','06.43','06.44',
        '06.45','06.46','06.47','06.48','06.49','06.50','06.51','06.52','06.53','06.54','06.55','06.56','06.57','06.58','06.59',
        '06.60','06.61','06.62','06.63','06.64','06.65','06.66','06.68','06.69','06.70','06.71','06.72','07.01','07.02','07.03',
        '07.04','07.05','07.06','07.07','07.08','07.09','07.10','07.11','07.12','07.13','07.14','07.15','07.16','07.17','07.18',
        '07.19','07.20','07.21','07.23','07.24','07.25','07.26','07.27','07.28','07.29','07.30','07.31','07.32','07.33','07.34',
        '07.35','07.36','08.07','08.08','08.09','08.10','08.12','08.14','08.15','08.16','08.17','08.18','08.19','08.20','08.21',
        '08.22','08.24','08.25','08.26','08.27','08.28','08.29','08.30','08.31','08.33','08.34','08.35','08.36','08.37','08.38',
        '08.39','08.40','08.41','08.42','08.43','08.45','08.46','08.47','08.48','08.49','08.51','08.52','08.53','08.54','08.57',
        '08.58','08.59','08.60','08.61'
      ]

      this.comparacaoCodModeloFamilia = listaCodFamiliaComCrea;
      this.comparacaoCodModeloFamiliaCAO = this.comparacaoCodModeloFamiliaCAO_;

    },
    // metodo para Comparação do codigo que a pessoa escole em Familia- Cadastrar Familia - Apenas para Exibir ou não umas msn
    comparacaoExibirMsnCreaEmAnexarDocumento(){
      for (let index = 0; index < this.comparacaoCodModeloFamilia.length; index++ ){
        if (this.comparacaoCodModeloFamilia[index] === this.modelFamilia.familia.codFamilia){
          return this.exibirMsnCreaEmAnexarDocumento = true ;

        }else this.exibirMsnCreaEmAnexarDocumento = false;
      }
    },
    

    comparacaoExibirMsnCAOEmAnexarDocumento(){      
      for (let index = 0; index < this.comparacaoCodModeloFamiliaCAO.length; index++ ){
        if (this.comparacaoCodModeloFamiliaCAO[index] === this.modelFamilia.familia.codFamilia){
          return this.exibirMsnCAOEmAnexarDocumento = true ;

        }else this.exibirMsnCAOEmAnexarDocumento = false;
      }
    },

    getFamilia(valor) {
      this.isLoadCombo = true;

      let descricao = valor;
 
      familiaService.getListaFamiliaCatalagoMat(descricao).then(response => {
        var familiaFiltrada = [];

        if (this.tipoFamilia !== "Todos") {
          response.data.filter(item => {
            if (item.tipoItem == this.tipoFamilia) familiaFiltrada.push(item);
          });

          response.data = familiaFiltrada;
        }

        this.hideNoData = false;
        this.listaFamilia = [];

        var array = [];
        var cabecalho = { header: null };
        var separador = { divider: false };

        response.data.filter(item => {
          if (item.descGrupo !== cabecalho.header) {
            if (separador.divider) array.push(separador);

            cabecalho = { header: item.descGrupo };

            array.push(cabecalho);
          }

          item.descFamilia = item.codFamilia + " - " + item.descFamilia;

          array.push(item);

          separador = { divider: true };
        });

        this.listaFamilia = response.data;
        this.isLoadCombo = false;
      });
      

    },

    salvar() {
      this.erroFamilia.erro = false;

      if (this.$refs.familiaForm.validate()) {
        if (this.modelFamilia.familia.codGrupo <= 9) {
          this.modelFamilia.familia.tipoQualificacao = 4;
        }
        this.modelFamilia.familia.idFornecSolicitacao = this.model.idFornecSolicitacao;
        this.modelFamilia.familia.numCgcFornecedor = this.model.numCgcFornecedor;

        this.getSocio();

        // Usando let ao invés de const
        let possuiSocioServidor =
          this.model.fornecedoresHabilitacaoJuridica.some(item => item.isFuncionarioPublico) ||
          this.model.isFuncionarioPublico;

        if (!this.model.isEmpresaPublica && possuiSocioServidor) {
          if (
            this.modelFamilia.familia.codFamilia === "01.46" &&
            this.model.numCgcFornecedor === "020.333.605-47"
          ) {
            // Exceção para a família "01.46"
          } else if (this.modelFamilia.familia.flagSocioServidor !== 1) {
            this.exibirDialogo();
            return;
          }

          const familiaInvalida = this.model.familiaSolicitacao.some(
            (f) => f.familiaAssociada.flagSocioServidor !== 1
          );

          if (familiaInvalida) {
            this.setErro(
              "Existem famílias inválidas na solicitação. Por favor, remova-as antes de continuar.",
              "tab-familias"
            );
            return;
          }
        }

        familiaService.salvar(this.modelFamilia).then((response) => {
         
          this.$refs.familiaForm.resetValidation();
          this.model.familiaSolicitacao = response.data;

          const objNovo = {
            codgrupo: this.modelFamilia.codGrupo,
            numFamilia: this.modelFamilia.numFamilia,
            exibeBotaoDeltar: true,
          };
              
         // this.listaFamiliaNova.push(objNovo);

          this.listaFamilia = [];
          this.modelFamilia = this.criarModelFamilia();
          this.montaAnexoFamilia();
          this.hideNoData = true;
         
          this.getListaDocsQualificacaoTecnica();
         
          this.$toasted.success(this.$t("messages.cadastro.sucesso"));
        });
      }
    },

    openBox(item) {
      //metodo para expandir e ocultar detalhes da familia
      const flag = this.isShow[
        item.$id + "_" + item.codGrupo + "_" + item.familiaAssociada.codFamilia
      ];

      this.$set(
        this.isShow,
        item.$id + "_" + item.codGrupo + "_" + item.familiaAssociada.codFamilia,
        !flag
      );
    },

    validaFamiliaDuplicidade(v) {
      //metodo que verifica se ja não fo icadastrada familia selecioanda
      const ifExiste = this.model.familiaSolicitacao.filter(item => {
        return item.familiaAssociada.codFamilia === v.codFamilia;
      });
      if (ifExiste.length) return false;
      else return true;
    },

    openModalRejeitar(itemLista) {
      this.itemRejeitado = itemLista;

      this.modelDialogRejeitar.open = true;
      this.modelDialogRejeitar.motivoSelecionado = this.itemRejeitado.idMotivoIndeferimentoArquivo;
      this.modelDialogRejeitar.codGrupo = itemLista.codGrupo;
      this.modelDialogRejeitar.numFamilia = itemLista.numFamilia;
    },

    /**
     * NOVO MÉTODO: Verificar se família foi resetada
     */
    familiaFoiResetada(familia) {
      if (!this.familiasResetadasParaReanalise || !this.familiasAfetadas.length) {
        return false;
      }
      
      return this.familiasAfetadas.some(function(resetada) {
        return resetada.codFamilia === familia.familiaAssociada.codFamilia;
      }) && familia.familiaFornecSituacao === null;
    },

    /**
     * MODIFICAR método existente: Aprovar família
     */

    aprovar(itemLista) {
      let model = Object.assign({}, itemLista);

      model.familiaFornecSituacao = 2;
      model.idMotivoIndeferimentoArquivo = null;
      
      familiaService.aprovarRejeitar(model).then(response => {
        this.model.familiaSolicitacao = response.data;
        this.montaAnexoFamilia();
        this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
        this.verificarSeTodasFamiliasForamReavaliadas(); // Verificar se todas famílias resetadas foram reavaliadas
      });
    },

    rejeitar() {
      let model = Object.assign({}, this.itemRejeitado);

      model.familiaFornecSituacao = 1;
      model.idMotivoIndeferimentoArquivo = this.modelDialogRejeitar.motivoSelecionado;

      familiaService.aprovarRejeitar(model).then(response => {
        this.model.familiaSolicitacao = response.data;
        this.montaAnexoFamilia();
        this.fnAcaoModalCancelar();
        this.verificarSeTodasFamiliasForamReavaliadas();
        this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
      });
    },
    /**
 * NOVO MÉTODO: Verificar se todas famílias resetadas foram reavaliadas
 */
    verificarSeTodasFamiliasForamReavaliadas() {
      if (this.familiasResetadasParaReanalise && this.familiasAfetadas.length > 0) {
        var todasReavaliadas = this.familiasAfetadas.every(familiaResetada => {
          var familiaAtual = this.model.familiaSolicitacao.find(f => {
            return f.familiaAssociada.codFamilia === familiaResetada.codFamilia;
          });
          return familiaAtual && familiaAtual.familiaFornecSituacao !== null;
        });
        
        if (todasReavaliadas) {
        
          this.familiasResetadasParaReanalise = false;
          this.contratoSocialFoiAlterado = false;
          this.familiasAfetadas = [];
          this.totalFamiliasResetadas = 0;
          this.motivoReanalise = '';
          
          this.$toasted.success(
            'Todas as famílias afetadas pela alteração do Contrato Social foram reavaliadas!', 
            { duration: 4000 }
          );
        }
      }
    },

    fnAcaoModalCancelar() {
      this.modelDialogRejeitar.open = false;
    },

    retornaDocPorIdFamilia(idFamiliaFornec) {
      return this.arrayFamiliasDocumento.find(
        x => x.idFamiliaFornec === idFamiliaFornec
      );
    },
    criarModelFamilia(){
      return {
        anexoFamiliaVm: {
          anexoFamilia:{
            arquivoUpload: null,
            codDocumento: 109
          },
          file: {
            arquivoUpload: null,
            novoUpload: true
          }
        }
      };
    },
    mergeAnexoFamilia(){
      this.modelFamilia =  {  ...this.criarModelFamilia(), ...this.modelFamilia};
       this.comparacaoExibirMsnCreaEmAnexarDocumento();
       this.comparacaoExibirMsnCAOEmAnexarDocumento();
    },
    baixarArquivo(arquivo) {
      var numCgcFornecedor  = this.model.numCgcFornecedor.replace(/[\W_]+/g,"");
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    montaAnexoFamilia(){
      this.model.familiaSolicitacao.filter(item => {
        let anexo =
        {
          anexoFamiliaSituacao: item.anexoFamilia ? item.anexoFamilia.anexoFamiliaSituacao : null,
          arquivoUpload: item.anexoFamilia ? item.anexoFamilia.arquivoUpload : null,
          codDocumento: 109,
          dtRejeicao: item.anexoFamilia ? item.anexoFamilia.dtRejeicao : null,
          idFamiliaSolicitacao: item.anexoFamilia ? item.anexoFamilia.idFamiliaSolicitacao : item.idFamiliaFornec,
          idMotivoIndeferimentoArquivo: item.anexoFamilia ? item.anexoFamilia.idMotivoIndeferimentoArquivo : null,
          file: {
            arquivoUpload: null,
            novoUpload: item.anexoFamilia && item.anexoFamilia.arquivoUpload ? false : true
          }
        }
        item.anexoFamilia = (item.anexoFamilia) ? {...item.anexoFamilia,...anexo} : anexo;
      });
     
    },
    arquivoAnexoFamilia(anexoFamilia){
      if(anexoFamilia.file.novoUpload){
        if(anexoFamilia.file.arquivoUpload != null){
          return anexoFamilia.file.arquivoUpload.filename;
        }
        return null;
      }else{
        return anexoFamilia.arquivoUpload;
      }
    },

    updateItem(item) {
      item.familiaFornecSituacao = null;
      item.idMotivoIndeferimentoArquivo = null;
      if(item.anexoFamilia != null){
        item.anexoFamilia.anexoFamiliaSituacao = null;
        item.anexoFamilia.dtRejeicao = null;
        item.anexoFamilia.idMotivoIndeferimentoArquivo = null;
      }
      familiaService.atualizar(item).then();
      this.getListaDocsQualificacaoTecnica();
    },

    verificaObrigatorio(){
      return this.model.tipoCertificado !== 3;
    },

    beforeDestroy: function() {
    
      // Limpar listeners específicos para Validadores
      if (this.$verificaPerfilHabilitador()) {
        this.$root.$off('contratoSocialAlterado');
        this.$root.$off('familiasResetadasParaReanalise');
      }
    }

  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}
</style>


